import {
	login,
	logout,
	getUserInfo
} from '@/utils/api/user'
import {
	getQueryString,
	GET_COOKIE,
	REMOVE_COOKIE
} from '@/utils/common'
import {
	resetRouter
} from '@/router/index'
import {
	Message
} from 'element-ui'
const state = {
	token: getQueryString('token') || GET_COOKIE('TOKEN'),
	companyName: null,
	avatar: '',
	permissions: [],
	hasInfo: false
}

const mutations = {
	SET_TOKEN: (state, token) => {
		state.token = token
	},
	SET_NAME: (state, name) => {
		state.companyName = name
	},
	SET_AVATAR: (state, avatar) => {
		state.avatar = avatar
	},
	SET_PERMISSIONS: (state, permissions) => {
		state.permissions = permissions
	},
	SET_INFOSTATUS: (state, infoStatus) => {
		state.hasInfo = infoStatus
	}
}

const actions = {
	getUserInfo({
		commit,
		state
	}) {
		return new Promise((resolve, reject) => {
			getUserInfo().then(response => {
				const {
					data
				} = response
				if (data) {
					if (data.roleInfos) {
						let permissions = []
						data.roleInfos.forEach(item => {
							permissions = [...permissions, ...item.permissions]
						})
						commit('SET_PERMISSIONS', permissions)
					}

					resolve(data)
					commit('SET_NAME', data.username)
					commit('SET_INFOSTATUS', true)
				}else{
					reject('数据错误')
				}

			}).catch(error => {
				reject(error)
			})
		})
	},

	// user logout
	logout({
		commit,
		state,
		dispatch
	}) {
		commit('SET_TOKEN', '')
		commit('SET_PERMISSIONS', [])
		REMOVE_COOKIE('TOKEN')
		// resetRouter()
		Message({
			message: '退出成功',
			type: 'success'
		});
	},

	// remove token
	resetToken({
		commit
	}) {
		return new Promise(resolve => {
			commit('SET_TOKEN', '')
			commit('SET_PERMISSIONS', [])
			REMOVE_COOKIE('TOKEN')
			resetRouter()
			resolve()
		})
	},
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
